var map = {
	"./barclays/TilesData.json": 1261,
	"./cb911/TilesData.json": 1262,
	"./globex/TilesData.json": 1263,
	"./lastminute/TilesData.json": 1264,
	"./outpayce/TilesData.json": 1265,
	"./sofi/TilesData.json": 1266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1260;